const event={
    duplicateSourceEid:null,
    avenueHubEid:null,
    avenueSlidePendingEid:null,
    isOpenLocaleStep:null,
};

export default event;